import { apim } from "./auth.service";

const addressValidate = async (query: any) => {
  try {
    return (
      await apim.get(
        `${process.env.REACT_APP_APIM_HOST}/maps/address/validate?query=${query}&country=USA&channel=ASR`
      )
    ).data;
  } catch (err: any) {
    console.log(err);
    return err.response;
  }
};
export default addressValidate;
